import { Svg } from 'components/svg'
import type { IconType } from 'models'

export const IconYoutube: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 512 512">
    <path
      d="M295.516,109.791a37.8,37.8,0,0,0-26.684-26.684C245.293,76.8,150.911,76.8,150.911,76.8s-94.382,0-117.922,6.308A37.8,37.8,0,0,0,6.306,109.791C0,133.329,0,182.439,0,182.439s0,49.11,6.306,72.645A37.8,37.8,0,0,0,32.989,281.77c23.54,6.305,117.922,6.305,117.922,6.305s94.382,0,117.922-6.305a37.8,37.8,0,0,0,26.684-26.686c6.305-23.535,6.305-72.645,6.305-72.645s0-49.111-6.305-72.648ZM120.727,227.713V137.165l78.414,45.274Z"
      transform="translate(105.089 73.562)"
      fill="currentColor"
    />
  </Svg>
)
